import ApiService from '@/services/ApiService';

export default class FindAddressesForPostcode {
    /**
     * ApiService instance.
     *
     * @var {ApiService}
     */
    apiService;

    /**
     * The base URL to use for postcodes API requests.
     *
     * @type {string}
     */
    baseUrl = `https://ws.postcoder.com/pcw/${process.env.VUE_APP_POSTCODER_API_KEY}/address/`;

    /**
     * FindAddressesForPostcode constructor.
     *
     * @param apiService
     */
    constructor(apiService = null) {
        this.apiService = apiService || new ApiService(this.baseUrl);
    }

    /**
     * Handle fetching the list of addresses associated with the given postcode string and country.
     *
     * @param {string} postcode
     * @param {string} countryIso
     *
     * @returns {Promise}
     */
    handle(postcode, countryIso = 'uk') {
        return this.apiService
            .get(`${countryIso}/${postcode}`, {
                params: {
                    lines: 2,
                },
            });
    }
}
